import { ColumnFilter } from '@tanstack/react-table';
import { useMemo } from 'react';

import { usePrepareFilters } from '@work4all/components';
import { IFilterPickerConfig } from '@work4all/components/lib/components/entity-picker/components/list-entity-picker';

export const StateFullPickerWrap: React.FC<{
  stateLessCfg: IFilterPickerConfig;
  render: (config: IFilterPickerConfig) => React.ReactElement<any>;
  columnFilters: ColumnFilter[];
}> = (props) => {
  const { filter } = usePrepareFilters(
    props.columnFilters,
    [],
    undefined,
    props.stateLessCfg?.parentEntityType
  );

  const stateFullCfg = useMemo(() => {
    if (props.stateLessCfg) return { ...props.stateLessCfg, filter };
    return null;
  }, [filter, props.stateLessCfg]);

  return props.render(stateFullCfg);
};
